import MuiButton, { type ButtonProps as MuiButtonProps } from '@mui/material/Button';
import { forwardRef, type MouseEvent } from 'react';
import { type TrackProperties, useTracking } from './tracking/TrackingContext.js';

export interface ButtonProps extends MuiButtonProps {
  trackEvent?: string;
  trackProps?: TrackProperties;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { trackEvent, trackProps, onClick, ...rest },
  ref,
) {
  const emit = useTracking();

  function handleClick(event: MouseEvent<HTMLButtonElement>): void {
    if (trackEvent !== undefined) emit(trackEvent, trackProps);
    onClick?.(event);
  }

  return <MuiButton ref={ref} onClick={handleClick} {...rest} />;
});
